import '.dt{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.du{padding-left:1.5rem;}.ssr-plugin'
import '.dv{margin:1rem 0;}.ssr-plugin'
import '.dw{color:var(--gray-700);}.ssr-plugin'
import '.dx{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="dt du dv dw dx"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
